import { render } from "./Text.vue?vue&type=template&id=f0f5ad38&scoped=true"
import script from "./Text.vue?vue&type=script&lang=ts"
export * from "./Text.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-f0f5ad38"

export default script